<template>
    <div class="contact-block" itemscope itemtype="http://schema.org/FurnitureStore">
        <div class="header" :class="{interactive: !!store.mark}" itemprop="name" @click="showPlacemark">
            <fa-icon :icon="faMapMarkerAlt" v-if="!!store.mark"></fa-icon>
            {{store.name}}
        </div>
        <div v-if="store.type !== 'own'" class="partner-label">Магазин партнеров</div>
        <div class="field">
            Адрес: <span itemprop="address">{{store.address}}</span>
        </div>
        <div class="field" v-if="store.time">
            Время работы: <span itemprop="openingHours">{{store.time}}</span>
        </div>
        <div class="field" v-if="store.phones.length">

            {{(store.phones.length == 1)?'Телефон':'Телефоны'}}:

            <a class="inline-list"
                itemprop="telephone"
                v-for="phone of store.phones"
                :href="'tel:'+phone"
                :key="phone">

                {{phone}}</a>
        </div>
        <div class="field" v-if="store.metro">
            Метро: {{store.metro}}
        </div>
    </div>
</template>

<script>

import {faMapMarkerAlt} from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt';

export default {
    props: ['store'],
    data: () => ({faMapMarkerAlt}),
    methods: {
        showPlacemark() {
            if (!this.store?.mark) {
                return;
            }

            this.store.mark?.balloon?.open();
            this.$emit('scrollToMap');
        }
    }
}
</script>

<style lang="scss" scoped>

@import '~/assets/css/colors.scss';

.contact-block {
    font-size: 16px;
    width: 100%;
    padding: 5px 10px;

    transition: background-color .1s ease;

    &:hover {
        background-color: $color-silver;
    }
}

.partner-label {
    font-size: 14px;
    color: $color-text-light;
}

.header {
    font-size: 18px !important;
}

.interactive {
    cursor: pointer;
}

.field {
    font-weight: 500 !important;
    span {
        font-weight: 400;
    }
}
</style>